import React, { useMemo } from 'react';
import type { MusicVideoSongMapSection } from 'fym-shared/src/music24/musicVideoApi';
import { TypedMemo } from '../../common/types';
import { sectionBarItems, type SectionTone } from './sectionBar';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from '../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

const TONE_CLASS: Readonly<Record<SectionTone, string>> = {
  intro: styles.secIntro ?? '',
  verse: styles.secVerse ?? '',
  chorus: styles.secChorus ?? '',
  bridge: styles.secBridge ?? '',
  outro: styles.secOutro ?? '',
};

/** The song map as one bar of sections (design `.mapbar`): a colour per kind, the length as share. */
const SectionMapBarComponent: React.FC<{ sections: readonly MusicVideoSongMapSection[] }> = ({ sections }) => {
  const items = useMemo(() => sectionBarItems(sections), [sections]);
  if (items.length === 0) {
    return null;
  }
  return (
    <div className={styles.mapBar}>
      {items.map((item) => (
        <span key={item.index} className={TONE_CLASS[item.tone]} style={{ flex: item.lengthSec }} title={item.label}>
          {item.short}
        </span>
      ))}
    </div>
  );
};

export const SectionMapBar = TypedMemo(SectionMapBarComponent);
